define([
	"./_Indentation",
	"./PluginFactory"
], function(_Indentation,PluginFactory) {

	return PluginFactory.declare(_Indentation, {
		"class": "csi-button-toggle csi-single-toggle",
		indentValue: "indent",
		materialIcon: "format_indent_increase",
		pluginName: "indent",
		title: "CanvasIncreaseIndent"
	});
});
